import { render } from "./WaybillDetail.vue?vue&type=template&id=6bf58856&scoped=true&ts=true"
import script from "./WaybillDetail.vue?vue&type=script&lang=ts"
export * from "./WaybillDetail.vue?vue&type=script&lang=ts"

import "./WaybillDetail.vue?vue&type=style&index=0&id=6bf58856&lang=scss&scoped=true"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf58856"]])

export default __exports__